// CoursesPage.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Typography,
  Button,
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CircularProgress,
  Alert,
  Box,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Navbar from "./Navbar";
import Footer from "./Footer";

const API = "https://course-selling-backend-2-rr1n.onrender.com";

function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await axios.get(`${API}/api/courses`);
        setCourses(res.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (loading)
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress />
      </Box>
    );
  if (error)
    return (
      <Container sx={{ mt: 5 }}>
        <Alert severity="error">Error: {error}</Alert>
      </Container>
    );

  // ✅ Buy button Razorpay integration
  const handleBuy = async (course) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Please login first!");
        return;
      }

      const orderRes = await axios.post(
        `${API}/api/payment/create-order`,
        { amount: course.price },
        { headers: { "x-auth-token": token } }
      );

      const { order } = orderRes.data;

      const options = {
        key: "rzp_live_RUUK4vJNXWL4ZP",
        amount: order.amount,
        currency: order.currency,
        name: "Medby Academy",
        description: course.title,
        order_id: order.id,
        handler: async function (response) {
          try {
            const verifyRes = await axios.post(
              `${API}/api/payment/verify`,
              {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                courseId: course._id,
              },
              { headers: { "x-auth-token": token } }
            );

            alert(verifyRes.data.message);
            window.location.href = "/mycourses";
          } catch (err) {
            alert("❌ Payment Verification Failed!");
          }
        },
        prefill: {
          name: "Student",
          email: "student@example.com",
          contact: "9999999999",
        },
        theme: { color: "#1976d2" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Payment Error:", err);
      alert("Something went wrong in payment!");
    }
  };

  return (
    <>
      {<Navbar />}

      {/* ✅ Hero Section */}
      <Box
        sx={{
          background: '#8a88bc',
          color: "white",
          py: 8,
          textAlign: "center",

        }}
      >
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          Explore Our Specialized Courses
        </Typography>
        <Typography variant="h6" maxWidth="600px" mx="auto">
          Gain professional skills, recognized certifications, and the knowledge to build a great career.
        </Typography>
      </Box>


      {/* ✅ Courses Section */}
      {/* ✅ Modern Courses Grid */}
      <Container sx={{ py: 8 }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          mb={6}
          color="darkgreen"
        >
          Our Popular Courses
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {courses.map((course) => (
            <Grid
              item
              key={course._id}
              xs={12}
              sm={6}
              md={4}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Card
                sx={{
                  width: 330,
                  height: 430,
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 4,
                  boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: "0 12px 25px rgba(0,0,0,0.2)",
                  },
                }}
              >
                {/* ✅ Thumbnail */}
                <Box sx={{ position: "relative" }}>
                  <CardMedia
                    component="img"
                    height="180"
                    image={
                      course.thumbnail?.startsWith("http")
                        ? course.thumbnail
                        : `${API}${course.thumbnail}`
                    }
                    alt={course.title}
                    sx={{
                      objectFit: "cover",
                      borderTopLeftRadius: "16px",
                      borderTopRightRadius: "16px",
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 8,
                      right: 8,
                      backgroundColor: "#1976d2",
                      color: "white",
                      px: 1.5,
                      py: 0.5,
                      borderRadius: "12px",
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                    }}
                  >
                    ₹{course.price}
                  </Box>
                </Box>

                {/* ✅ Course Info */}
                <CardContent
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    p: 3,
                  }}
                >
                  <Typography
                    gutterBottom
                    variant="h6"
                    component="h2"
                    sx={{
                      fontWeight: "bold",
                      mb: 1,
                      textAlign: "center",
                    }}
                  >
                    {course.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      textAlign: "center",
                      mb: 2,
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {course.desc}
                  </Typography>

               <Button
  variant="contained"
  fullWidth
  startIcon={<ShoppingCartIcon />}
  onClick={() => handleBuy(course)}
  sx={{
    borderRadius: "30px",
    textTransform: "none",
    fontWeight: "bold",
    py: 1.2,
    backgroundColor: "#2a9e7d; !important", // ✅ Force green background
    color: "white !important",
    "&:hover": {
      backgroundColor: "#1b5e20 !important", // ✅ Dark green on hover
    },
  }}
>
  Buy Now
</Button>


                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>


      <Footer />
    </>
  );
}

export default CoursesPage;
